export default "precision lowp float;\n#define GLSLIFY 1\n\nvarying vec4 eColor;\n\nvoid main(void) {\n\n    gl_FragColor = eColor;\n\n}\n"